const tabs = document.querySelector('.m-tabs');

if(tabs) {
  const tabBtns = tabs.querySelectorAll('[role="tab"]');
  const tabPanels = tabs.querySelectorAll('[role="tabpanel"]');

  tabBtns.forEach(button => button.addEventListener('click', handleTabClick));

  function handleTabClick(event) {
    // hide all panels
    tabPanels.forEach(panel => {
      panel.hidden = true;
    });

    // mark all tabs as unselected
    tabBtns.forEach(tab => {
      tab.setAttribute('aria-selected', false);
    });

    // select the clicked tab
    event.currentTarget.setAttribute('aria-selected', true);

    // show the associated panel
    const id = event.currentTarget.id;
    const tabPanel = tabs.querySelector(`[aria-labelledby="${id}"]`);
    tabPanel.hidden = false;
  }
}
